import React, { useEffect, useState } from "react";

import i18next from 'i18next'
import { Link, useNavigate } from "react-router-dom";
import { withoutAuthAxios } from "../config/config";
import { toast } from "react-toastify";
import IsLoadingHOC from "./IsLoadingHOC";
import { useDispatch, useSelector } from "react-redux";
import { setAccessToken, setIsAuthenticated, setuser } from "../Redux/Reducers/authSlice";
import { HiUser } from "react-icons/hi2";
import { IoMdLock } from "react-icons/io";
import { PiEyeLight, PiEyeSlash } from 'react-icons/pi';
import logo from "../assets/logo.png"
const Login = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.auth)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (accessToken) {
      navigate("/")
    }
  }, [])
  const { setLoading } = props;

  const [data, setdata] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setdata((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = data;

    setLoading(true);
    await withoutAuthAxios()
      .post("/admin/login", payload)
      .then((response) => {
        const resData = response.data;

        setLoading(false);

        // if (resData.status == 1) {
        //   if (resData.data.userType == "ADMIN") {
        //     toast.success(resData.message);
        //     dispatch(setAccessToken(resData.data.token));
        //     dispatch(setuser(resData.data));
        //     dispatch(setIsAuthenticated(true));
        //     navigate("/")
        //   } else {
        //     toast.error("You Don't Have Authorization  Access")
        //   }
        // } else {
        //   toast.error("Invalid Credentails");
        // }
        console.log("res",resData)
        
            toast.success(resData.message);
            dispatch(setAccessToken(resData.data.token));
            dispatch(setuser(resData.data.user));
            dispatch(setIsAuthenticated(true));
            navigate("/")
      })
      .catch((error) => {
        if(error.response?.data?.errors?.[0]?.email){
          toast.error(error.response?.data?.errors?.[0]?.email);
        }else{
          toast.error(error.response?.data?.message);
        }
        setLoading(false);
        // toast.error(error.response.data.message);
      });
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <div className="flex min-h-screen flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm z-[3]">
        <div className="logo--login">
          <img src={logo} alt="logo" width={150} height={30} />
        </div>
        <h2 className="text-center tracking-tight heading--login">
          Sign in
        </h2>
      </div>

      <div className="sm:mx-auto sm:w-full sm:max-w-sm login--form--admin">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Email address
            </label>
            <div className="mt-2">
              <div className="filter--input--search flex items-center bg-white rounded-[5px] h-[45px] border border-bordergray mr-[5px] auto--fill--none px-[15px]">

                <span className="input--icon border-r border-bordergray pr-[15px]">
                  <HiUser />
                </span>

                <input
                  id="email"
                  name="email"
                  type="email"
                  value={data.email}
                  onChange={handleChange}
                  autoComplete="email"
                  required
                  className="block w-full rounded-md border-0 py-1.5 px-4 text-gray-900 shadow-sm autofill:bg-white placeholder:text-gray-400 focus:shadow-[none] focus-visible:border-none focus-visible:shadow-[none] focus-visible:outline-0 sm:text-sm sm:leading-6"
                  placeholder="Enter your email"
                />
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium leading-6 text-gray-900"
            >
              Password
            </label>
            <div className="mt-2">
              <div className="filter--input--search flex items-center bg-white rounded-[5px] h-[45px] border border-bordergray mr-[5px] auto--fill--none px-[15px]">

                <span className="input--icon border-r border-bordergray pr-[15px]">
                  <IoMdLock />
                </span>
                <div className="relative w-full">
                  <input
                    id="password"
                    name="password"
                    value={data.password}
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    required
                    className="block w-full rounded-md border-0 py-1.5 px-4 text-gray-900 shadow-sm autofill:bg-white placeholder:text-gray-400 focus:shadow-[none] focus-visible:border-none focus-visible:shadow-[none] focus-visible:outline-0 sm:text-sm sm:leading-6 "
                    placeholder="Enter your password"
                  />
                  <div className="passwod--visibitly absolute top-[10px] right-[0] cursor-pointer" onClick={handleTogglePasswordVisibility}>
                    {showPassword ? <PiEyeLight /> : <PiEyeSlash />}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="w-full flex items-center border border-buttonbg  justify-center bg-buttonbg text-white py-[8px] px-[15px]  rounded-[5px] duration-[0.3s] hover:bg-transparent hover:text-textcolor h-[45px] font-[600]"
            >
              Login
            </button>
          </div>
        </form>

        {/* 
        <div className="flex items-center justify-between mt-5">
          <p className="text-sm text-gray-500">
            Not a member?{" "}
            <Link
              to="/signup"
              className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500"
            >
              Signup
            </Link>
          </p>
          <div className="text-sm">
            <a
              href="#"
              className="font-semibold text-indigo-600 hover:text-indigo-500"
            >
              Forgot password?
            </a>
          </div>
        </div>
        */}

      </div>
    </div>
  );
};

export default IsLoadingHOC(Login);
